const Login = () => import(/* webpackChunkName: "login" */ './pages/login/App')
const ForgetPassword = () => import(/* webpackChunkName: "forgetPassword" */ './pages/forget-password/App')
const Account = () => import(/* webpackChunkName: "account" */ './pages/account/App')
const Authenticate = () => import(/* webpackChunkName: "authenticate" */ './pages/authenticate/App')
const AuthenticateWithoutAuth = () => import(/* webpackChunkName: "authenticateWithoutAuth" */ './pages/authenticate/App')
const Binding = () => import(/* webpackChunkName: "binding" */ './pages/binding/App')
const Certificate = () => import(/* webpackChunkName: "certificate" */ './pages/certificate/App')
const CompanyRegister = () => import(/* webpackChunkName: "company-register" */ './pages/company-register/App')
const Deregistration = () => import(/* webpackChunkName: "deregistration" */ './pages/deregistration/App')
const FfpBinding = () => import(/* webpackChunkName: "ffp-binding" */ './pages/ffp-binding/App')
const Infomation = () => import(/* webpackChunkName: "infomation" */ './pages/infomation/App')
const InfomationAgent = () => import(/* webpackChunkName: "infomation-agent" */ './pages/infomation-agent/App')
const Password = () => import(/* webpackChunkName: "password" */ './pages/password/App')
const notLoginPassword = () => import(/* webpackChunkName: "not-login-password" */ './pages/not-login-password/App')
const Register = () => import(/* webpackChunkName: "register" */ './pages/register/App')
const Security = () => import(/* webpackChunkName: "security" */ './pages/security/App')
const SubAgent = () => import(/* webpackChunkName: "sub-agent" */ './pages/sub-agent/App')
const ThirdPartyLogin = () => import(/* webpackChunkName: "third-party-login" */ './pages/third-party-login/App')
const ProfessionalIdAuth = () => import(/* webpackChunkName: "professional-id-auth" */ './pages/professional-id-auth/App')

export default [
  {
    path: '/',
    redirect: '/account'
  },
  {
    path: '/login',
    component: Login
  },
  {
    path: '/forget-password',
    component: ForgetPassword
  },
  {
    path: '/account',
    component: Account
  },
  {
    path: '/authenticate',
    component: Authenticate
  },
  {
    path: '/authenticate-without-auth',
    component: AuthenticateWithoutAuth
  },
  {
    path: '/binding',
    component: Binding
  },
  {
    path: '/login-binding',
    component: Binding
  },
  {
    path: '/certificate',
    component: Certificate
  },
  {
    path: '/company-register',
    component: CompanyRegister
  },
  {
    path: '/deregistration',
    component: Deregistration
  },
  {
    path: '/ffp-binding',
    component: FfpBinding
  },
  {
    path: '/infomation',
    component: Infomation
  },
  {
    path: '/infomation-agent',
    component: InfomationAgent
  },
  {
    path: '/password',
    component: Password
  },
  {
    path: '/not-login-password',
    component: notLoginPassword
  },
  {
    path: '/register',
    component: Register
  },
  {
    path: '/security',
    component: Security
  },
  {
    path: '/sub-agent',
    component: SubAgent
  },
  {
    path: '/third-party-login',
    component: ThirdPartyLogin
  },
  {
    path: '/professional-id-auth',
    component: ProfessionalIdAuth
  },
  {
    name: '404',
    path: '/404',
    beforeEnter: () => {
      // window.location.replace('/404')
      window.__MICRO_ROOT__?.router?.replace('/404')
    }
  }
]
